export default __webpack_public_path__ + "static/media/close-icon.fd389b01.svg";